export const toggleLoading = ( state ) => {
    state.loading = !state.loading
}

export const activeLoading = ( state ) => {
    state.loading = true
}

export const disactiveLoading = ( state ) => {
    state.loading = false
}

export const setToast = (state, payload) => {
    state.toast = payload
}